function initMainListCollection() {
  const mainListCollection = document.querySelectorAll(".js-main-list-collections");

  if (!mainListCollection || mainListCollection.length == 0) {
    return;
  } else {

    mainListCollection.forEach((collectionWrap) => {

      const numberWrapper = collectionWrap.querySelector(".collection__number");
      const number = collectionWrap.querySelector(".collection__number h1");

      gsap.from(number,{
        xPercent: -100,
        scrollTrigger: {
          trigger: numberWrapper,
          // pin: true,
          start: 'top bottom',
          end: 'top top',
          scrub: 1
        }
      });

    });

  }
}

initMainListCollection();

function initCollectionGallerySwiper() {
  const collectionSwiper = document.querySelectorAll('.js-collection-gallery-swiper');

  if (!collectionSwiper || collectionSwiper.length == 0) {
    return;
  } else {

    collectionSwiper.forEach((swiper) => {

      const initCollectionSwiper = new Swiper(swiper, {
        loop: true,
        grabCursor: false,
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        initialSlide: 0,
        on: {
          click() {
            initCollectionSwiper.slideTo(this.clickedIndex + 1);
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          // prevEl: ".swiper-button-prev",
        }
      });

    });
  }
}

initCollectionGallerySwiper();
